<template lang="pug">
  .comment
    template( v-if="isOpen || value.length <= 3")
      Comment(v-for="( comment, i ) in value" :key="'comment'+i" :value="comment")
    Send( :task="task")
    .comment-submit(v-if="commentsCount > 3 && !isOpen" @click="loadComments")
      | Показать все комментарии ({{ commentsCount }})
</template>
<script>
import Send from './Send';
import Comment from './Comment';

export default {
  components: {
    Send,
    Comment
  },
  props: {
    task: {},
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    commentsCount() {
      return this.value.length;
    }
  },
  methods: {
    loadComments() {
      this.isOpen = true;
    }
  }
};
</script>
